import { Box, CrudMode, DataDisplay, Grid, ValidationErrors, pn, useElementBreakpoints } from "@compass/core";
import { Breakpoint } from "@mui/material";
import { Address, ModelPropertyBase } from "generated/openApi";
import { Input } from "./Input";
import produce from "immer";

export const AddressFields = (props: {
  crudMode: CrudMode;
  properties: ModelPropertyBase[];
  address: Address;
  setAddress: (value: Address) => void;
  validationErrors: ValidationErrors | string[];
  spacing?: Breakpoint;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const properties = props.properties;
  const spacing = props.spacing ?? "sm";

  const addressField = () => {
    const propertyName = pn<Address>("addressLine");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.address.addressLine}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.address.addressLine}
        onChange={(e) =>
          props.setAddress(
            produce(props.address, (draft) => {
              draft.addressLine = e.target.value;
            })
          )
        }
      />
    );
  };

  const cityField = () => {
    const propertyName = pn<Address>("city");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.address.city}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.address.city}
        onChange={(e) =>
          props.setAddress(
            produce(props.address, (draft) => {
              draft.city = e.target.value;
            })
          )
        }
      />
    );
  };

  const stateField = () => {
    const propertyName = pn<Address>("state");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.address.state}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        maxLength={2}
        value={props.address.state}
        onChange={(e) => {
          if (!/\d/.test(e.target.value)) {
            props.setAddress(
              produce(props.address, (draft) => {
                draft.state = e.target.value;
              })
            );
          }
        }}
      />
    );
  };

  const postalField = () => {
    const propertyName = pn<Address>("postal");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.address.postal}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.address.postal}
        onChange={(e) => {
          if (/^[^a-zA-Z]*$/.test(e.target.value)) {
            props.setAddress(
              produce(props.address, (draft) => {
                draft.postal = e.target.value;
              })
            );
          }
        }}
      />
    );
  };

  return (
    <Box ref={breakpointsRef}>
      <Grid container spacing={spacing}>
        <Grid item xs={setBreakpoints({  xs: 12 })}>
          {addressField()}
        </Grid>

        <Grid item xs={setBreakpoints({ xs: 12 })}>
          {cityField()}
        </Grid>

        <Grid item xs={setBreakpoints({ xs: 12 })}>
          {stateField()}
        </Grid>

        <Grid item xs={setBreakpoints({  xs: 12 })}>
          {postalField()}
        </Grid>
      </Grid>
    </Box>
  );
};
